import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

const serializeEmployeeProductionParams = (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(key, item));
            return;
        }
        searchParams.append(key, value);
    });

    return searchParams.toString();
};

export const getEmployeeProductionReport = async (filters) => {
    try {
        const token = Cookies.get("Bearer");
        const params = {
            dateRange: [filters.startDate, filters.endDate],
            serviceId: filters.serviceId,
            employeeId: filters.employeeId,
            departmentId: filters.departmentId,
            teamId: filters.teamId,
            includeInactive: Boolean(filters.includeInactive),
        };

        if (filters.serviceYear) {
            params.serviceYear = filters.serviceYear;
        }

        const response = await axios.get(
            `${FIRMFLOWURL}api/Analytics/EmployeeProductionReport`,
            {
                headers: { Authorization: token },
                params,
                paramsSerializer: serializeEmployeeProductionParams,
            },
        );

        return response.data;
    } catch (error) {
        console.error("Error loading Employee Production Report:", error);
        if (error?.response?.status === 401 || error?.message?.includes("401")) {
            Cookies.remove("Bearer");
            window.location.replace("/");
        }
        throw error;
    }
};
